import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { EcommerceGenericoService, SucursalEcommerce } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { CheckboxCategorias, CheckboxSubcategoria } from '../../etc/categoria-checkbox.interface';
import { MarianomGeneral } from '../../marianom-general.service';

@Component({
  selector: 'create-user-mmax',
  templateUrl: './create-user-mmax.component.html',
  styleUrls: ['./create-user-mmax.component.scss']
})

export class CreateUserMmaxComponent implements OnInit {
  @Input('mode') modo: string;
  @Input() sucSelector: string;


  errorForm: string;
  imagen: string;
  createForm: UntypedFormGroup;
  sucursalSelecionadaSelect: CheckboxSubcategoria;
  sucursalesPropias: SucursalEcommerce[];
  sucursalSelecionada: SucursalEcommerce;
  sucursales: CheckboxCategorias;
  seleccionada: boolean;
  hayErr: boolean;
  constructor(private formBuilder: UntypedFormBuilder, private serv: MarianomGeneral, private genServ: EcommerceGenericoService, private modal: ModalService, private router: ActivatedRoute) {
    this.imagen = '../../assets/misc/compra.png';
    this.seleccionada = false;
    this.hayErr = false;
    this.sucSelector = this.sucSelector || 'none';
    this.genServ.getSucursalesProviders().subscribe(data => {
      if (data.length == 1) {
        this.sucSelector = 'none';
      } else {
        this.sucSelector = 'flex';
      }
      let categorias: CheckboxSubcategoria[] = [];
      this.sucursalesPropias = data;
      data.forEach(k => {
        categorias.push({
          nombre: k.nombre,
          activada: false,
          id: k.sucursal.toString(),
        })
      })
      this.sucursales = { categorias: categorias, nombre: 'Sucursales' }
    });
  }

  ngOnInit(): void {
    this.router.data.subscribe(data => {
      this.modo = data['mode'] || this.modo || 'normal';
    });
    new Image().src = this.imagen;

    this.createForm = this.formBuilder.group({
      username: ['', [Validators.minLength(4), Validators.required]],
      dni: ['', [Validators.min(9999), Validators.required]],
      email: ['', [Validators.email, Validators.required]],
      password: ['', [Validators.minLength(8), Validators.required]],
      repeatpass: ['', [Validators.minLength(8), Validators.required]],
    });
  }

  get formFields() {
    return this.createForm.controls;
  }

  get validScuru(): boolean {
    if (this.sucursalSelecionada == undefined) {
      return true
    }
    else {
      return false;
    }
  }

  onSelect(event: CheckboxSubcategoria) {
    this.sucursalSelecionadaSelect = event;
    this.sucursalesPropias.forEach(k => {
      if (k.sucursal.toString() === event.id) {
        this.sucursalSelecionada = k;
        this.seleccionada = true;
      }
    })

  }

  salirMobile() {
    this.serv.goLandPage();
    this.serv.navigator.goLandPage(this.router);
  }

  async submitForm() {
    //console.log("SE EJECUTA REGISTRO");
    if (this.formFields.repeatpass.value != this.formFields.password.value) {
      //console.log("Las contraseñas no coinciden");
      this.modal.open('modal-pass-error');
    }
    else {
      //console.log(this.seleccionada);
      //console.log(this.sucSelector);

      if (this.seleccionada === false && this.sucSelector == 'flex') {
        this.modal.open('modal-seleccione-suc');
      }
      else {
        let sucursal;
        if (this.sucSelector == 'flex') {
          sucursal = this.sucursalSelecionada.sucursal;
        } else {
          sucursal = this.genServ.getSucursalDefecto();
        }

        await this.genServ.crearUsuario(
          this.formFields.username.value,
          this.formFields.dni.value,
          this.formFields.email.value,
          this.formFields.password.value,
          sucursal.toString()
        ).toPromise().catch(
          err => {
            //console.log("ERROR REGISTRO");
            //console.log(err);
            this.errorForm = 'El correo ingresado ya se encuentra en uso, por favor seleccione otro';
            setTimeout(() => {
              this.errorForm = '';
            }, 3000);
            this.hayErr = true;
            this.createForm.reset();
            if (this.createForm.valid) {
              //console.log('anda');
            }
          }
        );

        if (this.hayErr === false) {
          // El login usa el mail como usuario (el campo 'username' del form
          // es en realidad el nombre completo, no el identificador de login).
          const user = this.formFields.email.value.trim();
          const pass = this.formFields.password.value.trim();

          this.serv.llamarSpinner();
          this.genServ.loginStart(user, pass).subscribe(data => {
            this.serv.cerrarSpinner();
            this.serv.loginok();
            this.createForm.reset();
          }, err => {
            this.genServ.pendingFalse();
            this.serv.cerrarSpinner();
            this.serv.goLandPage();
            // console.log("Se registro exitosamente!");
            this.modal.close('create-user-modal-1');
            this.modal.open('login-modal-1');
            this.createForm.reset();
          });
        }
        this.hayErr = false;

      }
    }
  }
}
